import { useAuth } from "@/context/auth-context";
import { useApi } from "@/hooks/useApi";
import { useToast } from "@/hooks/useToast";
import { useEffect, useState } from "react";

export default function Rating({
	contentId,
	kind,
	disabled,
	rating,
	setRating,
	onSuccess,
	loading,
}: {
	contentId: string;
	kind: any;
	disabled: boolean;
	setRating: any;
	rating: number;
	onSuccess: any;
	loading?: any;
}) {
	const { user } = useAuth();
	const { addToast } = useToast();
	const { call: submitUserScore } = useApi();
	const [changed, setChanged] = useState(false);
	const [initialDisabled, setInitialDisabled] = useState(true);

	useEffect(() => {
		setInitialDisabled(disabled || loading);
	}, [disabled, loading]);

	const handleSubmitScore = async () => {
		try {
			if (!user) {
				addToast("برای ثبت امتیاز ابتدا وارد شوید", "info");
				return;
			}
			if (!changed) {
				return;
			}
			const res = await submitUserScore(
				"/api/score/submit",
				{
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({
						contentId: contentId,
						score: rating,
					}),
				},
				true,
			);
			if (res.success) {
				onSuccess();
			}
		} catch (err) {
			console.error("Failed to submit score:", err);
		}
	};

	return (
		<div>
			<h2 className="text-sm md:text-base whitespace-nowrap font-semibold">
				امتیاز کل {kind.name}
			</h2>

			<div className="flex flex-wrap gap-2 mt-2 justify-start items-center flex-row w-full">
				<div className="flex gap-2 justify-start items-center flex-nowrap">
					{[...Array(10)].map((_, index) => (
						<button
							key={index}
							className={`flex-1 min-w-[20px] sm:min-w-[30px] md:min-w-[48px] h-[26px] sm:min-h-[30px] md:h-[48px] rounded-md text-[10px] md:text-[16px] border-2 border-light-lime hover:opacity-70 ${
								rating > index
									? "bg-light-lime text-black"
									: "bg-light-lime/[.12] text-light-lime"
							}`}
							disabled={initialDisabled}
							onClick={() => {
								if (index + 1 !== rating) {
									setRating(index + 1);
								}
								setChanged(true);
							}}
						>
							{index + 1}
						</button>
					))}

					<button
						className="hidden md:block rounded-lg font-normal text-[10px] md:text-[18px] text-white bg-white/[.12] px-[10px] md:px-[24px] h-[48px] hover:opacity-70 min-w-[80px] flex-shrink-0 disabled:opacity-50"
						onClick={handleSubmitScore}
						disabled={initialDisabled}
					>
						ثبت امتیاز
					</button>
				</div>

				{/* Submit Score Button (Visible on Mobile) */}
				<button
					className="md:hidden rounded-lg font-normal text-[10px] text-white bg-white/[.12] px-[10px] py-3 sm:py-[17px] max-h-[26px] hover:opacity-70 flex justify-center items-center disabled:opacity-50"
					onClick={handleSubmitScore}
					disabled={disabled || loading}
				>
					ثبت امتیاز
				</button>
			</div>
		</div>
	);
}
